var map = {
	"./2013.jpg": 906,
	"./2014.jpg": 18,
	"./2015.jpg": 161,
	"./2021.jpg": 130,
	"./2022.jpg": 569,
	"./steam.jpg": 963,
	"./table_background.jpg": 81,
	"./west_lake.jpg": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;